
import state from './../../zviz2/zviz/state';
import {default as Group, Controller as GroupController} from './../../zviz2/zviz/components/group';
import TextBox from './../../zviz2/zviz/components/svg/textbox';
import Arc from './../../zviz2/zviz/components/arc';
import Rectangle from './../../zviz2/zviz/components/rectangle';
import Path from './../../zviz2/zviz/components/path';
import Vector from './../../zviz2/zviz/math/vector2';
import {extend, createObjectFromData, trimLowerCase} from './../../zviz2/zviz/functions';

//import {LifeCycle} from './../zviz2/zviz/cycle';
import flowModel from './../../model/flow';
import filterModel from './../../model/filter';
import config from './../../config';
import {styleText} from './../../styles';


class Controller extends GroupController{

    constructor(parent, blueprint={}){

        super(parent, blueprint);

        this.maxSize = 20;
        
    }

    isHovered(){
        let hover = state.get('map.itemHover');
        if(hover){
            let dim = hover[0];
            let value = hover[1];
            
            if(dim == this.data.dim && value == this.data.name){
                return true;
            }
        }
        return false;
    }

    getOpacity(){
        let hover = state.get('map.itemHover');
        if(hover && hover[0] == this.data.dim){
            return (hover[1] == this.data.name)? 1: 0.5;
        }else if(hover){
            let link = this.models['flow'].getLink(this.data.dim, this.data.name, hover[0], hover[1]);
            return (link==null)? 0.5: 1;
        }
        return 1;
    }

    getLinkPath(pos1, pos2){
       
        var dx = pos2.x - pos1.x;
        var dy = pos2.y - pos1.y;
        dx = (dx == 0)? 0.1: dx;
        
        // var slope = 0.5 * (pos2.y - pos1.y) / dx;

        // let cp1 = {x: pos1.x + 0.4 * dx, y: pos1.y + 0.4 * dx * slope};
        // let cp2 = {x: pos1.x + 0.8 * dx, y: pos1.y + 0.8 * dx * slope};
        let cp1 = {x: pos1.x, y: pos1.y + 0.4*dy};
        let cp2 = {x: pos2.x, y: pos2.y - 0.4*dy};

        return 'M' + pos1.x + ' ' + pos1.y + ' C'+cp1.x+' '+cp1.y + ', ' + 
                cp2.x+' '+cp2.y + ', ' + pos2.x + ' ' + pos2.y;
    }

    getLinks(){
        let hover = state.get('map.itemHover');
        let result = [];
        if(hover){
            let links = [];
            if(hover[0] == this.data.dim && hover[1] == this.data.name){
                links = this.models['flow'].getLinks(this.data.dim, this.data.name);
            }else if(hover[0] != this.data.dim){
                let link = this.models['flow'].getLink(this.data.dim, this.data.name, 
                        hover[0], hover[1]);
                if(link){
                    links.push({
                        dimension: hover[0],
                        value: hover[1],
                        amount: link});
                }
            }

            for(let i = 0; i < links.length; i++){
                let item = links[i];

                let centroid = this.getControllerByUid('geodata').getLocation(item.value, item.dimension);
                if(centroid == null){
                    continue;
                }

                let coords = centroid.add({x: 0, y: config.display.mapOffset.top});

                let path = this.getLinkPath(new Vector(this.data.coords[0], this.data.coords[1]), coords); 

                result.push(extend({
                    properties: {
                        attributes: {
                            'd': path
                        },
                        style: {
                            stroke: '#7abfe2',
                            strokeWidth: '2px',
                            fill: 'transparent'
                        }
                    }
                }, Path));
            }

        }
        return result;
    }

    getColor(darker=false){
        // 'hsl(174,99%,26%)'
        let tc = 'other';
        const source = state.get('source');
        const themeDim = source === 'eval' || source === 'planned' ? 'theme' : source + '_theme';
        const themeCatDim = source === 'eval' || source === 'planned' ? 'theme_category' : source+ '_theme_category';
        if(this.data.dim == themeCatDim){
            tc = this.data.name;
        }else{
            let stc = state.get('filter.' + themeCatDim);
            if(stc){
                if(stc instanceof Array){
                    tc = (stc.length > 1)? 'unknown': stc[0];
                }else{
                    tc = stc;
                }
            }else{
                let theme = state.get('filter.' + themeDim);
                if(theme){
                    if(this.models['filter'].result[themeCatDim] && 
                            this.models['filter'].result[themeCatDim].length == 1){
                        let ftc = extend(this.models['filter'].result[themeCatDim][0], 
                                {v: ['v', '[unknown]'], a: ['a', 0]});
                        tc = ftc.v;
                    }else{
                        this.update();
                    }
                }
            }
        }

        let hsl = config.display.themeColors['other'];
        if(config.display.themeColors[trimLowerCase(tc)]){
            hsl = config.display.themeColors[trimLowerCase(tc)].slice(0);
        }
        if(darker == true){
            hsl[2] = Math.round(0.75*hsl[2]);
        }

        return 'hsl('+hsl[0]+','+hsl[1]+'%,'+hsl[2]+'%)'; 

    }


    getScale(){

        let amount = this.getAmount();

        return Math.max(5, Math.sqrt((amount / this.parent.maxValue)) * this.maxSize);
    }

    getAmount(){

        let hover = state.get('map.itemHover');
        let amount = 0;
        if(hover && hover[0] != this.data.dim){
            let link = this.models['flow'].getLink(this.data.dim, this.data.name, hover[0], hover[1]);
            amount = link || 0;
        }else{
            
            amount = this.data.amount;
        }
        return amount;
    }

    getSourceName(){
        let source = state.get('source');
        let sourceName = ' ' + config.data.sourceTitles[source];
        return sourceName;
    }

    showAmount(){

        if(this.parent.roomForItems < 60){
            let hover = state.get('map.itemHover');
            if(! hover){
                return false;
            }else{
                return this.isHovered();
            }
        }

        return true;
    }

    showTitle(){

        if(this.parent.roomForItems < 100){
            let hover = state.get('map.itemHover');
            if(hover){
                if(hover[0] == this.data.dim){
                    return this.isHovered();
                }
                return true;
            }
        }

        return true;

    }


    getName(){

        return this.data.name;
    }

} 


let Blueprint = extend({
    type: Controller,
    models: {
        'flow': null,
        'filter': null
    },
    listeners: [
        (ctrl) => (ctrl.addListener(ctrl.models['flow'], [ctrl, ctrl.update])),
        (ctrl) => (ctrl.addListener(ctrl.models['filter'], [ctrl, ctrl.update])),
        (ctrl) => (ctrl.addListener(state, [ctrl, ctrl.update], 'map.itemHover')),
        (ctrl) => (ctrl.addListener(state, [ctrl, ctrl.update], 'source'))
    ],
    properties: { 
        style: {cursor: (ctrl) => ( (state.get('filter.theme'))? 'default': 'pointer') } ,
        data: {
            hover: (ctrl) => (state.get('map.itemHover'))
        }
    },
    children: [
        extend({
            properties: {
                data: {
                    hover: (ctrl) => (state.get('map.itemHover'))
                }
            },
            children: [
                (ctrl) => ( ctrl.parent.getLinks() )
            ]
        }, Group),

        extend({
            properties: {
                attributes: {
                    'x': 0,
                    'y': 0,
                    'width': (ctrl) => (150 + ctrl.parent.maxSize),
                    'height': (ctrl) => (2.2 * ctrl.parent.maxSize)
                },
                transform: {
                    position: {
                        x: (ctrl) => ((ctrl.parent.data.position == 'top')?
                            ctrl.parent.data.coords[0] - ctrl.parent.maxSize:
                            ctrl.parent.data.coords[0] ),
                        y: (ctrl) => ((ctrl.parent.data.position == 'top')?
                            ctrl.parent.data.coords[1] - ctrl.parent.maxSize:
                            ctrl.parent.data.coords[1])
                    },
                    rotation: (ctrl) => ( (ctrl.parent.data.position == 'top')? -0.6: 0.6)
                },
                style: {
                    fill: 'transparent',
                    stroke: 'white',
                    strokeWidth: '0px'
                }
            }
        },Rectangle),

        extend({
            properties: {
                style: {
                    fill: (ctrl) => ( ctrl.parent.getColor() ),
                    stroke: (ctrl) => ( ctrl.parent.getColor(true) ),
                    strokeWidth: '2px',
                    fillOpacity: (ctrl) => ( ctrl.parent.getOpacity() ),
                    strokeOpacity: (ctrl) => ( ctrl.parent.getOpacity() )
                },
                attributes: {
                    'r': (ctrl) => ( ctrl.parent.getScale() + ' => transition 400 easein' ),
                    'cx': (ctrl) => (ctrl.parent.data.coords[0]),
                    'cy': (ctrl) => (ctrl.parent.data.coords[1])
                }
            }
        }, Arc),

        extend({
            properties: {
                style: extend({
                    fontSize: '9pt',
                    fill: 'black',
                    opacity: (ctrl) => ( ctrl.parent.showTitle()? '1': '0.2' )
                }, styleText),
                transform: {
                    position: {
                        x: (ctrl) => ( ctrl.parent.data.coords[0] + (ctrl.parent.maxSize + 7) * Math.cos(-1.3) ),
                        y: (ctrl) => ( (ctrl.parent.data.position == 'top')?
                                ctrl.parent.data.coords[1] + (ctrl.parent.maxSize + 7) * Math.sin(-1.3):
                                ctrl.parent.data.coords[1] + (ctrl.parent.maxSize + 7) * Math.sin(1.3) )
                    },
                    rotation: (ctrl) => ( (ctrl.parent.data.position == 'top')? -0.6: 0.6)
                },
                data: {
                    text: (ctrl) => ( ctrl.parent.data.name  ),
                    height: 12,
                    width: 140,
                    lineHeight: 12,
                    breakWord: true,
                    verticalAlign: 'bottom'
                }
            }
        },TextBox),

        (ctrl) => ( ctrl.showAmount()? extend({
            properties: {
                data: {
                    text: ctrl.getAmount() + ctrl.getSourceName(),
                    width: (170 - ctrl.getScale() - 10),
                }
            }
         }, BlueprintAmountLink): [] ),
        // (ctrl) => ( ctrl.isHovered()? createObjectFromDefault({}, tooltip): [] )
    ],
    events: {
        click: (event, ctrl) => {
            state.set('map.itemHover', null );  
            state.set('filter.' + ctrl.data.dim, ctrl.getName()) 
            state.set('tooltip', null);
        },
        mouseover: (event, ctrl) => {
            if(event.target.tagName.toLowerCase() == 'path'){
                state.set('map.itemHover', null ); 
                state.set('tooltip', null);
                return;
            }
            state.set('map.itemHover', [ctrl.data.dim, ctrl.getName()] );
            if(ctrl.renderOutput.result.querySelectorAll('.more').length > 0){
                state.set('tooltip', ctrl.data.name);
            }
        },
        mouseout: (event, ctrl) => { state.set('map.itemHover', null ); state.set('tooltip', null); },
    }
}, Group);


let BlueprintAmountLink = extend({
    properties: {
        style: extend({
            fontSize: '8pt',
            fill: '#ababab',
            textDecoration: 'underline',
            cursor: 'pointer'
        }, styleText),
        transform: {
            position: {
                x: (ctrl) => ( (ctrl.parent.data.position == 'top')?
                        ctrl.parent.data.coords[0] + 10 + (ctrl.parent.maxSize + 7) * Math.cos(-1.3):
                        ctrl.parent.data.coords[0] - 10 + (ctrl.parent.maxSize + 7) * Math.cos(-1.3) ),
                y: (ctrl) => ( (ctrl.parent.data.position == 'top')?
                        ctrl.parent.data.coords[1] + 10 + (ctrl.parent.maxSize +7) * Math.sin(-1.3):
                        ctrl.parent.data.coords[1] + 10 + (ctrl.parent.maxSize +7) * Math.sin(1.3) )
            },
            rotation: (ctrl) => ( (ctrl.parent.data.position == 'top')? -0.6: 0.6)
        },
        data: {
            text: (ctrl) => ( ctrl.parent.getAmount() + ctrl.parent.getSourceName() ),
            height: 20,
            width: (ctrl) => (170 - ctrl.parent.getScale() - 10),
            verticalAlign: 'top'
        }
    },
    events: {
        click: (event, ctrl) => {
            // setting the filter for this item will hapen by the parent event that will also fire
            state.set('view', 'list'); 
        }
    }
}, TextBox);

// let tooltip = {
//     type: TextBox,
//     properties: {
//         style: createObjectFromDefault({
//             fontSize: '9pt',
//             fill: '#000000',
//         }, styleText),
//         transform: {
//             position: {
//                 x: (ctrl) => ( (ctrl.parent.data.position == 'top')?
//                         ctrl.parent.data.coords[0] + 10 + 0.5*ctrl.parent.maxSize:
//                         ctrl.parent.data.coords[0] + 10 + 0.5*ctrl.parent.maxSize ),
//                 y: (ctrl) => ( (ctrl.parent.data.position == 'top')?
//                         ctrl.parent.data.coords[1] + 0.5*ctrl.parent.maxSize:
//                         ctrl.parent.data.coords[1] - 0.5*ctrl.parent.maxSize )
//             }
//         },
//         data: {
//             text: (ctrl) => ( ctrl.parent.data.name ),
//             height: 28,
//             width: 500,
//             verticalAlign: 'top'
//         }
//     },
//     events: {
//         click: (event, ctrl) => {
//             // setting the filter for this item will hapen by the parent event that will also fire
//             state.set('view', 'list'); 
//         }
//     }
// }

export default Blueprint;
export {Controller, Blueprint};

